// import { Component, OnInit } from '@angular/core';
// import { Router, NavigationEnd } from '@angular/router';
// import { filter } from 'rxjs/operators';
// import { RouterOutlet, RouterModule } from '@angular/router';
// import { AsideConsentComponent } from '../_shared/aside-consent/aside-consent.component';
// import { HeaderSharedService } from '../_services/header-shared.service';
// import { ButtonsModule } from 'axis-components';

// @Component({
//   selector: 'app-insured',
//   standalone: true,
//   templateUrl: './insured.component.html',
//   imports: [AsideConsentComponent, ButtonsModule, RouterOutlet, RouterModule],
// })
// export class InsuredComponent implements OnInit {
//   activeStepSet: string = 'digital';
//   consentSelection: string = '';

//   constructor(
//     public headerSharedService: HeaderSharedService,
//     private router: Router,
//   ) {}

//   ngOnInit(): void {
//     this.setStepsBasedOnRoute(this.router.url);

//     this.router.events
//       .pipe(filter((e) => e instanceof NavigationEnd))
//       .subscribe((event: NavigationEnd) => {
//         this.setStepsBasedOnRoute(event.urlAfterRedirects);
//       });
//   }

//   private setStepsBasedOnRoute(url: string): void {
//     if (url.includes('uimui-non-digital')) {
//       this.headerSharedService.switchToNonDigital('uimui');
//       this.activeStepSet = 'non-digital';
//       this.consentSelection = 'non-digital';
//     } else if (url.includes('pip-non-digital')) {
//       this.headerSharedService.switchToNonDigital('pip');
//       this.activeStepSet = 'non-digital';
//       this.consentSelection = 'non-digital';
//     } else if (url.includes('uimui-thankyou')) {
//       this.headerSharedService.markUIMUICompleted();
//       this.activeStepSet =
//         this.headerSharedService.consentSelection || 'digital';
//       this.consentSelection = 'digital';
//     } else {
//       if (
//         url.includes('uimui') &&
//         this.headerSharedService.flowModes['uimui'] === 'non-digital'
//       ) {
//         this.headerSharedService.revertToDigital('uimui');
//       }
//       if (
//         url.includes('pip') &&
//         this.headerSharedService.flowModes['pip'] === 'non-digital'
//       ) {
//         this.headerSharedService.revertToDigital('pip');
//       }
//       this.activeStepSet = 'digital';
//       this.consentSelection = 'digital';
//     }
//     this.headerSharedService.updateStepState(url);
//   }

//   handleConsentSelection(type: string): void {
//     this.consentSelection = type;
//     this.headerSharedService.consentSelection = type;
//     if (type === 'non-digital') {
//       if (this.router.url.includes('/uimui')) {
//         this.headerSharedService.switchToNonDigital('uimui');
//         this.router.navigate(['/insured/uimui-non-digital']);
//       } else if (this.router.url.includes('/pip')) {
//         this.headerSharedService.switchToNonDigital('pip');
//         this.router.navigate(['/insured/pip-non-digital']);
//       }
//     }
//   }

//   handleNonDigitalOption(option: string): void {
//     // Handle non-digital option if needed (e.g., form submission)
//   }
// }

import { Component, OnInit } from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterModule,
  RouterOutlet,
} from '@angular/router';
import { ButtonsModule } from 'axis-components';
import { filter } from 'rxjs/operators';
import { HeaderSharedService } from '../_services/header-shared.service';
import { AsideConsentComponent } from '../_shared/aside-consent/aside-consent.component';
import { RequestService } from '../_services/request/request.service';
@Component({
  selector: 'app-insured',
  standalone: true,
  templateUrl: './insured.component.html',
  imports: [AsideConsentComponent, ButtonsModule, RouterOutlet, RouterModule],
})
export class InsuredComponent implements OnInit {
  activeStepSet: string = 'digital';
  consentSelection: string = '';

  constructor(
    public headerSharedService: HeaderSharedService,
    private router: Router,
    public route: ActivatedRoute,
    private requestService: RequestService,
  ) {}

  ngOnInit(): void {
    this.requestService.getRequestDetails().subscribe({
      next: () => {
        // Check if we need to redirect based on available form types
        this.requestService.handleFormTypeRedirection(this.router);
        this.setStepsBasedOnRoute(this.router.url);
      },
      error: (err) => {
        console.error('Error fetching request details:', err);
      },
    });
    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.setStepsBasedOnRoute(event.urlAfterRedirects);
      });
  }

  private setStepsBasedOnRoute(url: string): void {
    if (url.includes('uimui-non-digital')) {
      this.headerSharedService.switchToNonDigital('uimui');
      this.activeStepSet = 'non-digital';
      this.consentSelection = 'non-digital';
    } else if (url.includes('pip-non-digital')) {
      this.headerSharedService.switchToNonDigital('pip');
      this.activeStepSet = 'non-digital';
      this.consentSelection = 'non-digital';
    } else if (url.includes('uimui-thankyou')) {
      this.headerSharedService.markUIMUICompleted();
      // Preserve non-digital mode for UIMUI on thank-you
      this.activeStepSet = this.headerSharedService.flowModes['uimui'];
      this.consentSelection = this.headerSharedService.flowModes['uimui'];
    } else if (url.includes('pip-thankyou')) {
      this.headerSharedService.markPIPCompleted();
      // Preserve non-digital mode for PIP on thank-you
      this.activeStepSet = this.headerSharedService.flowModes['pip'];
      this.consentSelection = this.headerSharedService.flowModes['pip'];
    } else {
      if (
        url.includes('uimui') &&
        this.headerSharedService.flowModes['uimui'] === 'non-digital'
      ) {
        this.headerSharedService.revertToDigital('uimui');
      }
      if (
        url.includes('pip') &&
        this.headerSharedService.flowModes['pip'] === 'non-digital'
      ) {
        this.headerSharedService.revertToDigital('pip');
      }
      this.activeStepSet = 'digital';
      this.consentSelection = 'digital';
    }
    this.headerSharedService.updateStepState(url);
  }

  handleConsentSelection(type: string): void {
    this.consentSelection = type;
    this.headerSharedService.consentSelection = type;
    if (type === 'non-digital') {
      if (this.router.url.includes('/uimui')) {
        this.headerSharedService.switchToNonDigital('uimui');
        this.router.navigate(['/insured/uimui-non-digital'], {
          queryParamsHandling: 'preserve',
        });
      } else if (this.router.url.includes('/pip')) {
        this.headerSharedService.switchToNonDigital('pip');
        this.router.navigate(['/insured/pip-non-digital'], {
          queryParamsHandling: 'preserve',
        });
      }
    }
  }
}
